import InnerComponent from '@Components/Reports';
import orgContainer from '@Components/AppContainer';

const ViewReportsPage = () => ((orgContainer(InnerComponent)));
export default ViewReportsPage;
